export const AUTH = {
    v1: {
        loginRequest: '/api/auth/login-request',
        candidateLoginRequest: '/api/auth/candidate-login-request',
        guestLoginRequest: '/api/auth/guest-login-request',
        verifyLoginOtp: '/api/auth/verify-login-otp',
        verifySession: '/api/auth/me',
        logout: '/api/auth/logout',
        resendOtp: '/api/auth/resend-otp',
        requestResetPassword: '/api/auth/request-reset-password',
        validateResetPasswordToken: '/api/auth/validate-reset-password-token',
		validateInitialLogin: '/api/auth/validate-initial-login',
        changePassword: '/api/auth/change-password',
        verifyInitialLogin: '/api/auth/verify-initial-login',
        setPassword: '/api/auth/set-password',
        reInitDeployment: '/api/auth/reinit-deployment'
    }
};

export const CANDIDATE_AUTH = {
    v1: {
        loginRequest: '/api/auth/candidate-login-request',
        verifyLoginOtp: '/api/auth/verify-login-otp',
        verifySession: '/api/auth/me',
        logout: '/api/auth/logout',
        resendOtp: '/api/auth/resend-otp',
        requestResetPassword: '/api/auth/request-reset-password',
        validateResetPasswordToken: '/api/auth/validate-reset-password-token',
        changePassword: '/api/auth/change-password',
        verifyInitialLogin: '/api/auth/verify-initial-login',
        setPassword: '/api/auth/set-password',
        reInitDeployment: '/api/auth/reinit-deployment'
    }
};

export const USER = {
    v1: {
        me: '/api/user/me',
        adminMe: '/api/user/admin-me',
        fetchUser: '/api/user',
        editUserInfo: '/api/user/edit-info',
        updateTour: '/api/user/update-tour'
    }
};

export const SETTINGS = {
    v1: {
        fetchPublicBranding: '/api/settings/public-branding',
        fetchClientSettings: '/api/settings/client-settings',
        updateLogo: '/api/settings/update-logo',
        updateSettings: '/api/settings/update-organisation-info',
        addOrganisationContact: '/api/settings/organisation-contacts',
        fetchSubscriptionList: '/api/settings/subscription-list',
        fetchCurrentSubscription: '/api/settings/current-subscription',
        updateNotification: '/api/settings/update-notification',
        updateLearnerForm: '/api/settings/update-learner-form',
        updateDefaultQuizLevel: '/api/settings/update-default-quiz-level',
        updateAutoIncludeCourseReady: '/api/settings/update-auto-include-course-ready',
        updateEmailTemplate: '/api/settings/update-email-template',
        fetchEmailTemplates: '/api/settings/email-templates',
        updateAxcelerate: '/api/settings/update-axcelerate',
        updateApiEnabled: '/api/settings/update-api-enabled',
        updateWisenetEnabled: '/api/settings/update-wisenet-enabled',
        updateWebhooks: '/api/settings/update-webhooks',
        updateDirectLinksStatus: '/api/settings/update-direct-links-status',
        updateThreshold: '/api/settings/update-threshold',
        updateFeatureSettings: '/api/settings/feature-settings'
    }
};

export const LOGS = {
    v1: {
        fetchLogs: '/api/logs'
    }
};

export const AUDIT_LOGS = {
    v1: {
        fetchAuditLogs: '/api/audit-logs',
        exportAuditLogs: '/api/audit-logs/export',
        fetchAuditFilterOptions: '/api/audit-logs/filter-options'
    }
};

export const UNITS = {
    v1: {
        fetchUnits: '/api/units'
    }
};

export const COURSES = {
    v1: {
        baseUrl: '/api/courses',
        saveAsDraft: '/api/courses/save-as-draft',
        checkExist: '/api/courses/check-exist-course',
        analytics: '/api/courses/analytics',
        duplicate: '/api/courses/duplicate',
        unitsRelationShipMatrix: '/api/courses/units-relationship-matrix',
        generateUnitOutcomeDetails: '/api/courses/generate-unit-outcome-details',
        unitOutcomeDetails: '/api/courses/unit-outcome-details'
    }
};

export const CANDIDATE_ASSESSMENTS = {
    v1: {
        baseUrl: '/api/candidate-assessments',
        options: '/api/candidate-assessments/options',
        invite: '/api/candidate-assessments/invite',
        candidateBaseUrl: '/api/candidate-assessments/candidate',
        generateResubmissionGuidance: '/api/candidate-assessments/resubmission-guidance',
        generateInterviewQuestions: '/api/candidate-assessments/interview-questions',
        checkValidTranscript: '/api/candidate-assessments/check-valid-transcript'
    }
};

export const CANDIDATES = {
    v1: {
        baseUrl: '/api/candidates'
    }
};

export const GUEST_EVIDENCE = {
    v1: {
        me: '/api/guest-evidence/me',
        information: '/api/guest-evidence/me/information',
        baseUrl: '/api/guest-evidence',
        candidateBaseUrl: '/api/guest-evidence/candidate',
        assessorBaseUrl: '/api/guest-evidence/assessor',
        invite: '/api/guest-evidence/invite',
        decline: '/api/guest-evidence/decline',
        submit: '/api/guest-evidence/submit',
        evidenceBaseUrl: '/api/guest-evidence/evidence',
        evidenceLibrary: '/api/guest-evidence/evidence/library',
        evidenceUploadUrl: '/api/guest-evidence/evidence/upload-url',
        evidenceLink: '/api/guest-evidence/evidence/link'
    }
};

export const ANALYTICS = {
    v1: {
        assessmentWorkloadOverview: '/api/analytics/get-assessment-workload-overview',
        assessmentSummary: '/api/analytics/get-assessment-summary',
        reports: '/api/analytics/reports'
    }
};

/**
 * Public IP API
 * 1. https://ipinfo.io/json
 * 2. http://ip-api.com/json
 * 3. https://api64.ipify.org?format=json (suggested best url for public ip)
 */
export const IP_INFO = {
    staticPublicIp: 'https://api64.ipify.org?format=json'
};

export const API_USERS = {
    v1: {
        fetchAll: '/api/api-users',
        create: '/api/api-users'
    }
};
